import React from "react";
import landingVideo from "../video/landing-video.mp4";
import { Car } from "lucide-react";
import HomeAbout from "../Components/Home_Component/HomeAbout";
import OurServices from "../Components/Home_Component/OurServices";
import WhyChooseUs from "../Components/Home_Component/WhyChooseUs";
import ServiceRequestForm from "../Components/ServiceRequestForm";
import MarqueeHighlights from "../Components/MarqueHighlights";

const services = [
  "Puzzle Parking",
  "Puzzle Pit Parking",
  "4 Level Pit Parking",
  "3 Level Parking",
  "3 Level Pit Parking",
  "2 Level Parking",
  "2 Level Pit Parking",
  "Tower Parking",
  "Rotary Parking",
];

const LandingPage = () => {
  return (
    <>
      <div className="lt-landing-wrapper">
        <video className="lt-landing-bg-video" autoPlay loop muted>
          <source src={landingVideo} type="video/mp4" />
        </video>

        <div className="lt-landing-content">
          <div className="lt-landing-left">
            <div className="lt-landing-headline">
              PARKING MADE EASY FOR <br />
              <span>EVERYONE</span>
            </div>
          </div>

          <div className="lt-landing-right">
            <div className="lt-form-glass-card">
              <h2>Quick Services Request</h2>
              <p>24 Hours Services Available!</p>
              <form className="lt-glass-form">
                <input type="text" placeholder="Name" required />
                <input type="tel" placeholder="Phone" required />
                <input type="email" placeholder="Email Address" required />
                <input type="text" placeholder="Zipcode" required />
                <select required>
                  {services.map((s, idx) => (
                    <option key={idx} value={s}>
                      {s}
                    </option>
                  ))}
                </select>
                <button type="submit">SUBMIT</button>
              </form>
            </div>
          </div>
        </div>
      </div>

      <HomeAbout />
      <OurServices />
      <WhyChooseUs />
      <ServiceRequestForm />
      <MarqueeHighlights />
    </>
  );
};

export default LandingPage;
